import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { GateWayService } from '../../services/gateway-service.service';

@Component({
  selector: 'app-user-page',
  templateUrl: './user-page.component.html',
  styleUrls: ['./user-page.component.scss']
})
export class UserPageComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private gwService: GateWayService,

  ) {
    localStorage.setItem('state', 'user');
  }

  async ngOnInit() {
    const state = 'user';
    const useDevLogin = this.route.snapshot.queryParamMap.get('devLogin') === 'true';
    const username = this.route.snapshot.queryParamMap.get('username');

    let gwToken = localStorage.getItem('access_token');
    if (gwToken) {
      console.log("HAVE LOCAL TOKEN")
      await this.gwService.verifyGWToken(gwToken, state)
        .subscribe(async success => {
          console.log("verifyGWToken success :", success)
          switch (success.code) {
            case 200:
              this.router.navigate(["/homepage"]);
              // true : this.router.navigate(["/manage-org"]); 
              break;
            case 400:
              this.router.navigate(["/error-page"], { queryParams: { state: state, errorCode: '00' } }).then(() => {
                localStorage.clear();
                window.location.reload();
              });
              break;
            case 401:
              this.router.navigate(["/error-page"], { queryParams: { state: state, errorCode: '00' } }).then(() => {
                localStorage.clear();
                window.location.reload();
              });
              break;
            case 403:
              this.router.navigate(["/error-page"], { queryParams: { state: state, errorCode: '02' } }).then(() => {
                localStorage.clear();
                window.location.reload();
              });
              break;
            default:
              this.router.navigate(["/error-page"], { queryParams: { state: state, errorCode: '00' } }).then(() => {
                localStorage.clear();
                window.location.reload();
              });
              break;
          }
        });
    } else {
      if (useDevLogin) {
        await this.gwService.devLogin(state, username).subscribe(success => {
          if (success.code == 200) {
            localStorage.setItem('access_token', success.data.access_token);
            localStorage.setItem('refresh_token', success.data.refresh_token);
            localStorage.setItem('username', success.data.userInfo.username);
            localStorage.setItem('display_name', success.data.userInfo.display_name);
            localStorage.setItem('system_role', success.data.userInfo.system_role);
            window.location.reload();
          } else {
            this.router.navigate(["/error-page"], { queryParams: { state: state, errorCode: '00' } });
          }
        });
        return;
      }
      await this.gwService.getADMDLoginURI(state).subscribe(success => {
        console.log("success :", success)
        if (success.code == 200) window.location.href = success.data.url
      });
    }
  }

}
